window.addEventListener("load", () => {
    const node = document.querySelector(".js-rector-btn");
    if(node) {
        node.addEventListener("click", (e) => {
            e.preventDefault();
            var event = new Event("click", {bubbles: true, cancelable: true});
            const line = document.querySelector(".b24-widget-button-openline_livechat");
            line.dispatchEvent(event);
        });
    }
});
